import * as React from 'react';
import { useEffect, useState, useCallback } from 'react';
import { ReactChildren } from 'react';
import ReactSlider from 'react-slider';

type SliderProps = {
    min: number,
    max: number,
    value: number,
    step: number,
    width: number,
    fillTrack: boolean,
    onAfterChange: (val: number) => void,
    onChange?: (val: number) => void,
    renderThumb?: (props, state) => void,
    scale?: ReactChildren,
    className?: string
};

function Slider({ min, max, value, step, fillTrack, scale, width, onChange, onAfterChange, renderThumb, className }: SliderProps): JSX.Element {
    const [sliderValue, setSliderValue] = useState(value);
    useEffect(() => {
        setSliderValue(value);
    }, [value]);

    const onChangeCb = useCallback((newVal) => {
        setSliderValue(newVal);
        if (onChange) {
            onChange(newVal);
        }
    }, [onChange]);

    const defaultRenderThumb = useCallback((props, state) => {
        return <div {...props}>
            <div className="slider-val">
                {sliderValue}
            </div>
        </div>;
    }, [sliderValue]);

    let style = {};
    if (width) {
        style = {
            minWidth: `${width}px`,
            width: `${width}px`,
            maxWidth: `${width}px`,
        }
    }
    return (
        <div className={`horizontal-slider ${className} ${fillTrack && 'fill-track'}`} style={style}>
            <ReactSlider
                min={min}
                max={max}
                defaultValue={sliderValue}
                step={step}
                onChange={onChangeCb}
                onAfterChange={onAfterChange}
                renderThumb={renderThumb || defaultRenderThumb}
                thumbClassName="slider-thumb"
                trackClassName="slider-track" />
            {scale}
        </div>
    );
}

export default Slider;